// Export all creation components as a single default object with lazy imports
export default {
  // Ledger Creation Components
  get LedgerCreation() {
    return import('./ledger/components/LedgerCreation.vue').then(m => m.default)
  },

  // SubLedger Creation Components
  get SubLedgerCreation() {
    return import('./subledger/components/SubLedgerCreation.vue').then(m => m.default)
  },

  // Head Master Creation Components
  get HeadMasterCreation() {
    return import('./HeadMaster/components/HeadMasterCreation.vue').then(m => m.default)
  },

  // Group Master Creation Components
  get GroupCreation() {
    return import('./GroupMaster/components/GroupCreation.vue').then(m => m.default)
  },

  // Company Master Creation Components
  get CompanyMasterCreation() {
    return import('./companyMaster/components/CompanyMasterCreation.vue').then(m => m.default)
  },

  // Currency Creation Components
  get CurrencyCreation() {
    return import('./currency/components/CurrencyCreation.vue').then(m => m.default)
  },
  get ExchangeRateCreation() {
    return import('./currency/components/ExchangeRateCreation.vue').then(m => m.default)
  },

  // Voucher Type Creation Components
  get VoucherTypeCreation() {
    return import('./voucherType/components/VoucherTypeCreation.vue').then(m => m.default)
  },

  // Budget Creation Components
  get BudgetCreation() {
    return import('./budget/components/BudgetCreation.vue').then(m => m.default)
  },

  // Financial Year Creation Components
  get FinancialYearCreate() {
    return import('./financialYear/components/FinancialYearCreate.vue').then(m => m.default)
  },

  // Bank Master Creation Components (Note: Uses popup pattern)
  get BankMasterPopup() {
    return import('./bankMaster/components/BankMasterPopup.vue').then(m => m.default)
  },

  // Cost Center Creation Components (Note: Uses popup pattern)
  get CostCenterPopup() {
    return import('./costCenter/components/CostCenterPopup.vue').then(m => m.default)
  },

  // Cost Center Mapping Creation Components (Note: Uses popup pattern)
  get CostCenterMappingPopup() {
    return import('./costCenterMapping/components/CostCenterMappingPopup.vue').then(m => m.default)
  },

  // Tax Components Creation (Note: Uses popup pattern)
  get TaxComponentPopup() {
    return import('./taxComponent/components/TaxComponentPopup.vue').then(m => m.default)
  },
  get TaxMasterPopup() {
    return import('./taxMaster/components/TaxMasterPopup.vue').then(m => m.default)
  },
  get TaxTypePopup() {
    return import('./taxType/components/TaxTypePopup.vue').then(m => m.default)
  },

  // HSN Creation Components (Note: Uses popup pattern)
  get HSNPopup() {
    return import('./hsn/components/HSNPopup.vue').then(m => m.default)
  },

  // Ledger Type Creation Components (Note: Uses popup pattern)
  get LedgerTypePopup() {
    return import('./ledgertype/components/LedgerTypePopup.vue').then(m => m.default)
  },

  // Unit Creation Components (Note: Uses popup pattern)
  get UnitPopup() {
    return import('./unit/components/UnitPopup.vue').then(m => m.default)
  },

  // Cheque Book Master Creation Components (Note: Uses popup pattern)
  get ChequeBookMasterPopup() {
    return import('./chequeMaster/components/ChequeBookMasterPopup.vue').then(m => m.default)
  },

  // Voucher Entry Components
  get FinancialVoucherEntryScreen() {
    return import('./Transaction/Voucher/components/FinancialVoucherEntryScreen.vue').then(m => m.default)
  },
  get InventoryVoucherEntryScreen() {
    return import('./Transaction/Voucher/components/InventoryVoucherEntryScreen.vue').then(m => m.default)
  },
  get SalesandPurchasevoucher() {
    return import('./Transaction/Voucher/components/SalesandPurchasevoucher.vue').then(m => m.default)
  }
}
